<script setup>
import { computed } from 'vue'
import { useConfigStore } from '@/stores/ConfigStore'
import { useBillingStore } from '@/stores/BillingStore'

const emit = defineEmits(['upgrade'])

const props = defineProps({
  text: { type: String, default: 'Upgrade' },
  buttonClass: { type: String, default: '' },
  icon: { type: String, default: 'heroicons:fire-16-solid' },
  textPopoverButtonClass: { type: String, default: '' },
  additionalIcon: { type: String, default: '' },
})

const configStore = useConfigStore()
const billingStore = useBillingStore()

const subscription = computed(() => configStore.getConfigField('subscription'))
const hasActiveSubscription = computed(() => configStore.getConfigField('hasActiveSubscription'))
const topPlan = computed(() => billingStore.topPlan)

const handleUpgrade = () => {
  emit('upgrade')
};
</script>
<template>
  <button 
    class="group p-2 bg-blue-50 rounded flex items-center gap-x-1.5 transition duration-300 text-tint-1"
    :class="[buttonClass]"
    @click="handleUpgrade"
    aria-label="Handle Upgrade"
  >
    <template
      v-if="
        subscription?.plan_id &&
        (!subscription ||
          (hasActiveSubscription &&
            subscription?.plan_id !== topPlan?.id))
      "
    >
      <Icon v-if="!additionalIcon" :icon="icon" class="text-base" :class="textPopoverButtonClass" />
      <Icon v-else :icon="additionalIcon" class="text-base" :class="textPopoverButtonClass" />
      <span class="text-xs font-semibold text-tint-1" :class="textPopoverButtonClass">{{ text }}</span>
      <Icon v-if="additionalIcon" :icon="icon" class="text-base" :class="textPopoverButtonClass" />
    </template>
    <template
      v-else-if="
        subscription?.plan_id &&
        subscription &&
        !hasActiveSubscription
      "
    >
      <Icon icon="heroicons:bolt" />
      <span class="text-xs font-semibold">Reactivate Account</span>
    </template>
    <template v-else>
      <div class="w-[88px] invisible h-0"></div>
    </template>
  </button>
</template>